module.exports = __webpack_public_path__ + "static/fonts/Mont-Heavy.e82ce7e.woff2";